import { Microsoft as MicrosoftIcon } from '@mui/icons-material';
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

interface LocationState {
  from?: {
    pathname: string;
  };
}

const Login: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      const destination = state?.from?.pathname || '/';
      navigate(destination, { replace: true });
    }
  }, [isAuthenticated, navigate, state]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            The Perk Portal
          </Typography>

          <Typography variant="h6" align="center" color="textSecondary" paragraph>
            Sign in to access your perks
          </Typography>

          <Stack spacing={2} sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              startIcon={<MicrosoftIcon />}
              onClick={login}
              sx={{ py: 1.5 }}
            >
              Sign in with Microsoft
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
